import { IPresentationSheetContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const PresentationSheetContext = createContext<IPresentationSheetContextData>({} as IPresentationSheetContextData);
